import { mapValues } from 'lodash';
import { BaseController } from '../../base_controller';

const UNIQUE_ID = 'elections--prior-vote-results-component';

export const EVENTS = (() => {
  const events = {
    LOAD_ADDITIONAL_RESULTS: 'load_additional_results',
  };

  return mapValues(events, (name) => `${UNIQUE_ID}:${name}`);
})();

export default class extends BaseController {
  public viewMore(): void {
    this.emitLoadAdditionalResults();
  }

  private emitLoadAdditionalResults() {
    this.dispatch(EVENTS.LOAD_ADDITIONAL_RESULTS, {
      // @ts-ignore
      prefix: null,
    });
  }
}
